var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsNeedsImage24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #234492;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.49,32.05c.32-.47,.56-1.03,.97-1.41,.83-.76,2.12-.74,3.02-.06,.21,.16,.39,.34,.58,.52,3.59,3.59,7.18,7.18,10.77,10.77,.14,.14,.25,.3,.47,.57,.18-.25,.28-.44,.43-.59,9.75-9.75,19.5-19.5,29.24-29.25,.75-.75,1.59-1.17,2.68-.88,1.73,.47,2.41,2.54,1.3,3.94-.14,.18-.3,.34-.46,.5-10.39,10.39-20.78,20.79-31.18,31.18-1.05,1.05-2.17,1.29-3.25,.66-.28-.16-.53-.38-.76-.61-4.3-4.29-8.6-8.57-12.87-12.89-.41-.41-.63-1-.94-1.5,0-.33,0-.65,0-.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsNeedsImage24);
export default __webpack_public_path__ + "static/media/UDS Needs Image-24.a683a424f7899d55ce9a818581456284.svg";
export { ForwardRef as ReactComponent };